export const CURRENCY_SYMBOLS = {
  PKR: "Rs",
  IDR: "Rp",
};

export const formatAmountWithCurrency = (amount, currency) => {
  const num = Number(amount ?? 0);
  const code = String(currency || "PKR").toUpperCase();
  const symbol = CURRENCY_SYMBOLS[code] || code;
  return `${symbol} ${num.toLocaleString()}`;
};

export const getAmount = (tx) => Number(tx?.amount ?? 0);
export const getFeeAmount = (tx) => Number(tx?.feeAmount ?? 0);
export const getNetAmount = (tx) => Number(tx?.netAmount ?? (getAmount(tx) - getFeeAmount(tx)));
